import { Type } from '@/types';

export interface TypesState {
  types: Type[];
}

export const namespaced = true;

export const state = (): TypesState => ({
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  types: (window as any).$store.types || [],
});

export const getters = {
  canvas(state) {
    return state.types.find((type) => type.name === 'CANVAS');
  },
  behang(state) {
    return state.types.find((type) => type.name === 'BEHANG');
  },
};
